import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AccessCheckService } from './access-check.service';

export function noRoleGuard(
  redirectUrl: string[],
  allowedRoles: string[],
): CanActivateFn {
  return () => {
    const router: Router = inject(Router);
    const accessCheckService: AccessCheckService = inject(AccessCheckService);

    return accessCheckService.hasRequiredRole(allowedRoles).pipe(
      map((hasRole: boolean) => {
        if (hasRole) {
          return router.createUrlTree(redirectUrl);
        }
        return true;
      }),
    );
  };
}
